// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__n6DVP","skillsContainer":"Skills_skillsContainer__jEp89","skillBlock":"Skills_skillBlock__-JhlY"};